import React, { Dispatch } from 'react';
import { Tag, Card, List } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../store/ducks/movimentacoes/actions';
import { ApplicationState } from '../../../../store';
import CardSecMobile from '../CardSecMobile';
import ModalAtendimentoEntrada from '../Modal';
import { RowLine, SpanBlock } from './styles';
import ModalStatus from '../ModalStatus';

const CardMobile: React.FC<any> = ({ props, loading, inscricaoAtiva, cddAtivo, filter }) => {
  const pagination = useSelector((state: ApplicationState) => state.Movimentacoes.pagination);
  const dispatch = useDispatch<Dispatch<Action>>();

  let color: string;
  let name: string;
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'ANFC':
        color = 'warning';
        break;
      case 'CR':
        color = 'success';
        break;
      case 'NC':
        color = 'blue';
        break;
      default:
        color = 'default';
        break;
    }
    return color;
  };
  const getStatusName = (status: string) => {
    switch (status) {
      case 'ANFC':
        name = 'Aguardando nota de cobertura';
        break;
      case 'CR':
        name = 'Cobertura Realizada';
        break;
      case 'NC':
        name = 'Não necessita cobertura';
        break;
      default:
        name = '';
        break;
    }
    return name;
  };
  const paginationProps = {
    onChange: (pag: any) => {
      const resultado = {
        ...pagination,
        current: pag,
      };
      dispatch(
        loadRequest(
          filter,
          filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
          cddAtivo?.codEmp,
          resultado
        )
      );
    },
    showSizeChanger: true,
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
  };

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      pagination={paginationProps}
      loading={loading}
      dataSource={props}
      renderItem={(item: any) => (
        <List.Item>
          <Card title={props.nuNota}>
            <RowLine>
              <p>
                <strong>N° Único</strong>
                <SpanBlock> {item.nuNota} </SpanBlock>
              </p>
              <p>
                <strong>Nota</strong>
                <SpanBlock>
                  <ModalAtendimentoEntrada
                    text={item.numNota}
                    nuNota={item.nuNota}
                    chave={item.chaveNfe}
                  />
                </SpanBlock>
              </p>
              <p>
                <strong>Status</strong>
                <SpanBlock>
                  <Tag style={{ textTransform: 'uppercase' }} color={getStatusColor(item.status)}>
                    <ModalStatus
                      props={{ status: item.status, necessitaCobertura: item.necessitaCobertura }}
                    >
                      {getStatusName(item.status)}
                    </ModalStatus>
                  </Tag>
                </SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Data Lançamento</strong> <SpanBlock>{item.dtLancamento}</SpanBlock>
              </p>
              <p>
                <strong>Data emissão</strong> <SpanBlock>{item.dtEmissao}</SpanBlock>
              </p>
            </RowLine>
            <p>
              <strong>Depositante</strong> <SpanBlock>{item.parceiro}</SpanBlock>
            </p>
            <p>
              <strong>Emitente</strong> <SpanBlock>{item.emitente}</SpanBlock>
            </p>
            <p>
              <strong>Pagador da Armazenagem</strong>{' '}
              <SpanBlock>{item.pagadorArmazenagem}</SpanBlock>
            </p>
            <RowLine>
              <p>
                <strong>Tempo Armazenagem Contratado</strong>
                <SpanBlock>{item.tempoArmazenagemContratado}</SpanBlock>
              </p>
              <p>
                <strong>Tempo Restante</strong> <SpanBlock>{item.tempoRestante}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Peso Bruto</strong> <SpanBlock>{item.pesoBruto}</SpanBlock>
              </p>
              <p>
                <strong>Valor da Mercadoria</strong> <SpanBlock>{item.vlrMercadoria}</SpanBlock>
              </p>
            </RowLine>
            <CardSecMobile nuNota={item.nuNota} />
          </Card>
        </List.Item>
      )}
    />
  );
};
export default CardMobile;
